<template>
	<!-- took out id="app" below -->
  <div>
    <v-app>
      <!-- Sizes your content based upon application components -->
      <v-main>
				<app-header></app-header>
        <!-- Provides the application the proper gutter -->
        <v-container fluid id="mainContent">
          <router-view></router-view>
        </v-container>
				<v-snackbar
          top
          v-model="snackbar"
					:color="snackbarColor"
					:timeout="0"
        >
          <p class="p2" v-if="updateStatus" v-html="snackbarMessage"></p>

          <template v-slot:action="{ attrs }">
            <v-btn
							text
              v-bind="attrs"
              @click="snackbar = false"
							class="snackbar-close-btn"
            >
							<span class="d-sr-only">close</span>
              <v-icon>
								close
							</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-main>

			<app-footer app></app-footer>
    </v-app>
  </div>
</template>

<script>
import AppFooter from '@/components/common/AppFooter';
import AppHeader from '@/components/common/AppHeader';

export default {
	name: 'app',
	components: {
		'app-footer': AppFooter,
		'app-header': AppHeader
	},
	metaInfo: {
		htmlAttrs: {
			lang: 'en'
		},
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: 'ASA24 Researcher Site',
		// all titles will be injected into this template
		titleTemplate: '%s | ASA24 Researcher Site'
	},
	data: () => ({
		snackbar: false,
		snackbarColor: null,
		snackbarMessage: null,
		snackTimeout: -1
	}),
	mounted () {
		// Call store actions to load data
		this.$store.dispatch('loadStudyVersions');
	},
	computed: {
		statusesList: function () {
			return this.$studyStatusList.statusesList;
		},
		updateStatus: function () {
			var status = this.$store.getters.getStatusUpdate;
			this.updateSnackbar(status);
			return status;
		}
	},
	methods: {
		async updateSnackbar (status) {
			this.snackTimeout = await this.$store.getters.getAlertTimeout;
			switch (status) {
			case 'generic-success':
				this.snackbarColor = 'green';
				this.snackbarMessage = this.$store.getters.getStatusMessage;
				this.snackbar = true;
				break;
			case 'generic-error':
				this.snackbarColor = 'red';
				this.snackbarMessage = this.$store.getters.getStatusMessage;
				this.snackbar = true;
				break;
			case 'generic-success':
				this.snackbarColor = 'green';
				this.snackbarMessage = this.$store.getters.getStatusMessage;
				this.snackbar = true;
				break;
			case 'new-study':
				this.snackbarColor = this.statusesList[0].color;
				this.snackbarMessage = this.statusesList[0].status;
				this.snackbar = true;
				break;
			case 'deleted-study':
				this.snackbarColor = this.statusesList[1].color;
				this.snackbarMessage = this.statusesList[1].status;
				this.snackbar = true;
				break;
			case 'contact-success':
				this.snackbarColor = this.statusesList[2].color;
				this.snackbarMessage = this.statusesList[2].status;
				this.snackbar = true;
				break;
			case 'contact-error':
				this.snackbarColor = 'red'
				this.snackbarMessage = this.$store.getters.getStatusMessage;
				this.snackbar = true;
				break;
			case 'register-user-success':
				this.snackbarColor = this.statusesList[3].color;
				this.snackbarMessage = this.statusesList[3].status;
				this.snackbar = true;
				break;
			case 'register-user-fail':
				this.snackbarColor = 'red';
				this.snackbarMessage = this.$store.getters.getStatusMessage;
				this.snackbar = true;
				break;
			case 'profile-success':
				this.snackbarColor = this.statusesList[4].color;
				this.snackbarMessage = this.statusesList[4].status;
				this.snackbar = true;
				break;
			case 'profile-fail':
				this.snackbarColor = 'red';
				this.snackbarMessage = this.$store.getters.getStatusMessage;
				this.snackbar = true;
				break;
			case 'password-update-success':
				this.snackbarColor = this.statusesList[5].color;
				this.snackbarMessage = this.statusesList[5].status;
				this.snackbar = true;
				break;
			case 'password-update-fail':
				this.snackbarColor = 'red';
				this.snackbarMessage = this.$store.getters.getStatusMessage;
				this.snackbar = true;
				break;
			case 'user-details-update-success':
				this.snackbarColor = this.statusesList[6].color;
				this.snackbarMessage = this.statusesList[6].status;
				this.snackbar = true;
				break;
			case 'user-details-update-fail':
				this.snackbarColor = 'red';
				this.snackbarMessage = this.$store.getters.getStatusMessage;
				this.snackbar = true;
				break;
			case 'wizard-error':
				this.snackbarColor = 'red';
				this.snackbarMessage = this.$store.getters.getStatusMessage;
				this.snackbar = true;
				break;
			case 'delete-respondents-success':
				this.snackbarColor = this.statusesList[7].color;
				this.snackbarMessage = this.statusesList[7].status;
				this.snackbar = true;
				break;
			case 'delete-respondents-fail':
				this.snackbarColor = 'red';
				this.snackbarMessage = this.$store.getters.getStatusMessage;
				this.snackbar = true;
				break;
			case 'new-study-draft':
				this.snackbarColor = this.statusesList[8].color;
				this.snackbarMessage = this.statusesList[8].status;
				this.snackbar = true;
				break;
			case 'deleted-study-draft':
				this.snackbarColor = this.statusesList[9].color;
				this.snackbarMessage = this.statusesList[9].status;
				this.snackbar = true;
				break;
			case 'admin-message-success':
				this.snackbarColor = this.statusesList[10].color;
				this.snackbarMessage = this.statusesList[10].status;
				this.snackbar = true;
				break;
			case 'delete-recalls-success':
				this.snackbarColor = this.statusesList[11].color;
				this.snackbarMessage = this.statusesList[11].status;
				this.snackbar = true;
				break;
			case 'delete-recalls-fail':
				this.snackbarColor = 'red';
				this.snackbarMessage = this.$store.getters.getStatusMessage;
				this.snackbar = true;
				break;
			case 'admin-message-failure':
				this.snackbarColor = 'red';
				this.snackbarMessage = this.$store.getters.getStatusMessage;
				this.snackbar = true;
				break;
			default:
				this.snackbarColor = 'white';
				this.snackbarMessage = 'Default Message';
				this.snackbar = false
			}
		}
	}
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
